import { useMutation } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { MESSAGES } from '@/modules/shared/constants/messages'
import { useToast } from '@/modules/shared/hooks/use-toast'
import type { MutationRequest } from '@/modules/shared/types/mutation-request.type'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

import {
  type ScheduleDeletePayload,
  scheduleDeleteService,
} from '../services/delete-schedule.service'

export const useDeleteScheduleMutation = ({
  callback,
  resolveRequest,
}: MutationRequest) => {
  const { toast } = useToast()
  const { mutateAsync: deleteSchedule, isSuccess: successDeleteOrder } =
    useMutation({
      mutationFn: (data: ScheduleDeletePayload) => scheduleDeleteService(data),
      onSuccess: (data) => {
        resolveRequest({
          status: data.status,
          showToastInfo: true,
          message: data.message,
          showToastSuccess: true,
          callback,
        })
      },
      onError: (error: AxiosError<ResponseAPI>) => {
        if (
          error.response?.data?.status > 400 &&
          error.response?.data?.status < 500
        ) {
          if (error.response?.data?.message) {
            toast.info({
              title: error.response.data.message,
            })
          } else {
            toast.error({
              title: MESSAGES.ERROR_TITLE,
              description: MESSAGES.ERROR_DESCRIPTION,
              action: {
                label: MESSAGES.RELOAD,
                onClick: () => {
                  window.location.reload()
                },
              },
            })
          }
        } else if (
          error.response?.data?.status > 400 &&
          error.response?.data?.status < 500 &&
          error.response?.data?.message
        ) {
          toast.info({
            title: error.response.data.message,
          })
        } else {
          toast.error({
            title: MESSAGES.ERROR_TITLE,
            description: MESSAGES.ERROR_DESCRIPTION,
            action: {
              label: MESSAGES.RELOAD,
              onClick: () => {
                window.location.reload()
              },
            },
          })
        }
      },
    })

  return {
    deleteSchedule,
    successDeleteOrder,
  }
}
